import { MeasurementTypes } from "../../enums/kpiStats/measurement-types.enum";

export function formatValue(value: number, opt?: { currencySymbol?: string, unit?: string }): string {
  if (value === null || value === undefined) {
    return 'N/A';
  }

  return `${opt?.currencySymbol || ''}${transformValue(value)} ${opt?.unit || ''}`;
}

export function formatDropdownValue(value: number, selectedUnit: string, dropdownOptions: { value: string; unit: string }[], getEnumFromString: (unit: string) => MeasurementTypes, currencySymbol: string = "R"): string {
  if (value === null || value === undefined) {
    return 'N/A';
  }

  const selectedOption = dropdownOptions.find(opt => opt.value === selectedUnit);
  const displayUnit = selectedOption?.unit || '';
  const selectedEnum = getEnumFromString(selectedUnit);

  switch (selectedEnum) {
    case MeasurementTypes.FuelConsumption:
      return `${transformValue(value)} ${displayUnit}`;
    case MeasurementTypes.FuelEconomy:
      return `${transformValue(value)} ${displayUnit}`;
    case MeasurementTypes.CostPerUnit:
      return `${currencySymbol}${transformValue(value)}${displayUnit}`;
    case MeasurementTypes.Percentage:
      return `${value.toLocaleString('default', { maximumFractionDigits: 2 })}%`;
    default:
      return `${transformValue(value)} ${displayUnit}`;
  }
}

export function formatCost(value: number, unit: string = 'R'): string {
  return `${unit}${transformValue(value)}`;
}

export function formatCostDifference(value: number, selectedFilter: string = 'last month', unit: string = 'R'): string {
  if (value === null || value === undefined) {
    return 'N/A';
  }

  const absValue = Math.abs(value);
  const formattedValue = `${unit}${transformValue(absValue)}`;
  const sign = value > 0 ? '+' : value < 0 ? '-' : '';

  return `${sign}${formattedValue} vs ${selectedFilter}`;
}

export function formatPercentageDifference(value: number, selectedFilter: string): string {
  const sign = value > 0 ? '+' : value < 0 ? '-' : '';
  const absValue = Math.abs(value);
  
  return `${sign}${absValue.toLocaleString('default', { maximumFractionDigits: 2 })}% vs ${selectedFilter}`;
}

export function getEnumFromString(value: string): MeasurementTypes {
  const enumValue = parseInt(value) as MeasurementTypes;
  const isValid = Object.values(MeasurementTypes).includes(enumValue);
  return isValid ? enumValue : MeasurementTypes.Volume;
}

export function transformValue(value: number): string {
  if (value >= 1_000_000) {
    const v = Math.trunc((value / 1_000_000) * 100) / 100;
    return `${v.toLocaleString('default', { maximumFractionDigits: 2 })}M`;
  }

  if (value >= 1_000) {
    const v = Math.trunc((value / 1_000) * 100) / 100;
    return `${v.toLocaleString('default', { maximumFractionDigits: 2 })}K`;
  }

  return value.toLocaleString('default', { maximumFractionDigits: 2 });
}